import script from "./Manage.vue?vue&type=script&lang=ts&setup=true"
export * from "./Manage.vue?vue&type=script&lang=ts&setup=true"

import "./Manage.vue?vue&type=style&index=0&id=64676d04&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64676d04"]])

export default __exports__